import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    items: [],
    proposalsLeadSources: [],
    proposalStatusesSummary: []
}

export default {mutations, actions, state}